import { MetricReader } from '@opentelemetry/sdk-metrics';
import { ExportResultCode } from '@opentelemetry/core';
import { diag } from '@opentelemetry/api';
import { throttle } from '../utils/throttle.mjs';

class InstantaneousMetricReader extends MetricReader {
  constructor({
    exporter,
    throttleLimit
  }) {
    var _exporter$selectAggre, _exporter$selectAggre2;
    super({
      aggregationSelector: (_exporter$selectAggre = exporter.selectAggregation) === null || _exporter$selectAggre === void 0 ? void 0 : _exporter$selectAggre.bind(exporter),
      aggregationTemporalitySelector: (_exporter$selectAggre2 = exporter.selectAggregationTemporality) === null || _exporter$selectAggre2 === void 0 ? void 0 : _exporter$selectAggre2.bind(exporter)
    });
    this._exporter = void 0;
    this._exporter = exporter;
    this.onForceFlush = throttle(
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.onForceFlush, throttleLimit);
  }
  async onForceFlush() {
    const {
      resourceMetrics,
      errors
    } = await this.collect({});
    if (errors.length > 0) {
      diag.error('PeriodicExportingMetricReader: metrics collection errors', ...errors);
    }
    return new Promise((resolve, reject) => {
      this._exporter.export(resourceMetrics, result => {
        if (result.code === ExportResultCode.SUCCESS) {
          resolve();
        } else {
          var _result$error;
          reject((_result$error = result.error) !== null && _result$error !== void 0 ? _result$error : new Error(`InstantaneousMetricReader: metrics export failed (error ${result.error})`));
        }
      });
    });
  }
  async onShutdown() {
    await this._exporter.shutdown();
  }
}

export { InstantaneousMetricReader };
